import React, {useState, useEffect} from 'react'
import {Route, Routes, useParams, useLocation} from 'react-router-dom'
import ReportData from './ReportData'
import ResponseListDatewise from './ResponseListDatewise'
import {useNavigate} from 'react-router-dom'

const ResponseWrapper: React.FC = () => {
  const {id, date} = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [view, setView] = useState<'grouped' | 'all' | ''>('grouped')

  // Update view state based on route
  useEffect(() => {
    if (date) {
      setView('')
    } else if (location.pathname === `/reports/${id}` && view === '') {
      // Check if we're at the base route and view needs initialization
      setView('grouped')
    }
  }, [date, location.pathname, id, view])

  const handleViewChange = (viewChange: 'grouped' | 'all') => {
    setView(viewChange)
    navigate(`/reports/${id}`)
  }

  return (
    <section>
      <div className='flex justify-end mb-4'>
        <div className='btn-group'>
          <button
            className={`btn btn-light-primary ${view === 'grouped' ? 'active' : ''}`}
            onClick={() => handleViewChange('grouped')}
          >
            Datewise
          </button>
          <button
            className={`btn btn-light-primary ${view === 'all' ? 'active' : ''}`}
            onClick={() => handleViewChange('all')}
          >
            Overall
          </button>
        </div>
      </div>
      <Routes>
        <Route
          path='/*'
          element={
            view === 'all' ? <ReportData /> : <ResponseListDatewise date={view} setView={setView} />
          }
        />
        {view !== 'all' && <Route path='/:date/*' element={<ReportData />} />}
      </Routes>
    </section>
  )
}

export default ResponseWrapper
